import { Flex } from 'foundations-components/components/Flex';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { SuiteBadge } from '../../../common/badges/SuiteBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const renderTitle = ({
  productLevel,
  showProductLevelTitle
}) => {
  switch (productLevel) {
    case 'STARTER':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.starterCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.starterCard.title"
      });
    case 'PROFESSIONAL':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.professionalCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.professionalCard.title"
      });
    case 'ENTERPRISE':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.enterpriseCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.enterpriseCard.title"
      });
    default:
      return undefined;
  }
};
export const SuiteCardTitle = ({
  productLevel,
  showProductLevelTitle = false
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(SuiteBadge, {
      productLevel: productLevel
    }), /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: renderTitle({
          productLevel,
          showProductLevelTitle
        })
      })
    })]
  });
};